var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00065 0.666626C7.46089 0.666626 7.83398 1.03972 7.83398 1.49996V11.1548L8.9114 10.0774C9.23683 9.75193 9.76447 9.75193 10.0899 10.0774C10.4153 10.4028 10.4153 10.9304 10.0899 11.2559L7.58991 13.7559C7.43363 13.9122 7.22166 14 7.00065 14C6.77964 14 6.56768 13.9122 6.4114 13.7559L3.9114 11.2559C3.58596 10.9304 3.58596 10.4028 3.9114 10.0774C4.23683 9.75193 4.76447 9.75193 5.08991 10.0774L6.16732 11.1548V1.49996C6.16732 1.03972 6.54041 0.666626 7.00065 0.666626ZM0.333984 16.5C0.333984 16.0397 0.70708 15.6666 1.16732 15.6666H12.834C13.2942 15.6666 13.6673 16.0397 13.6673 16.5C13.6673 16.9602 13.2942 17.3333 12.834 17.3333H1.16732C0.70708 17.3333 0.333984 16.9602 0.333984 16.5Z",
    fill: "#033972"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.67b763a96f67531ec5ffe8fd30032993.svg";
export { ForwardRef as ReactComponent };